module.exports = __webpack_public_path__ + "static/media/warning.82e58e4d.svg";